import React, { useEffect, useState } from "react";
import { ReactComponent as RsjcLogo } from "../assets/RsjcLogo.svg";
import { ReactComponent as RsjcWhiteLogo } from "../assets/rsjc_logo_white-01.svg";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [scrolling, setScrolling] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div
      className={`z-50 fixed top-0 left-0 w-full font-bold ${
        scrolling
          ? "bg-white text-[#0F2849] shadow-md"
          : "bg-transparent text-white"
      } ease-in-out duration-300`}
    >
      <div className="flex justify-between items-center px-6 md:px-20 py-4">
        {/* Logo */}
        <Link to={"/"} className="flex-shrink-0">
          {scrolling ? (
            <RsjcLogo className="w-[140px] md:w-[180px]" />
          ) : (
            <RsjcWhiteLogo className="w-[140px] md:w-[180px]" />
          )}
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex space-x-6">
          <Link to="/">
            <li className="p-2">Home</li>
          </Link>
          <Link to="/club">
            <li className="p-2">Club</li>
          </Link>
          <Link to="/venue-fees">
            <li className="p-2">Venues & Fees</li>
          </Link>
          <Link to="/what-is-judo">
            <li className="p-2">What is Judo</li>
          </Link>
          <Link to="/team">
            <li className="p-2">Team</li>
          </Link>
          <Link to="/calendar">
            <li className="p-2">Calendar</li>
          </Link>
          <Link to="/gallery">
            <li className="p-2">Gallery</li>
          </Link>
          <Link to="/links">
            <li className="p-2">Links</li>
          </Link>
          <Link to="/contact">
            <li className="p-2">Contact</li>
          </Link>
        </ul>

        {/* Mobile Menu Icon */}
        <div onClick={handleNav} className="md:hidden cursor-pointer z-50">
          {!nav ? <AiOutlineMenu size={28} /> : <AiOutlineClose size={28} />}
        </div>
      </div>
      {/* Mobile Menu */}
      <div
        className={`fixed top-0 left-0 w-full h-full bg-white text-[#0F2849] transform ${
          nav ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out`}
      >
        <div className="flex justify-between items-center px-6 py-4 text-[#0F2849]">
          <Link to={"/"}>
            <RsjcLogo className="w-[140px]" />
          </Link>
          <div onClick={handleNav} className="cursor-pointer text-[#0F2849]">
            <AiOutlineClose size={28} z={100} />
          </div>
        </div>

        <ul className="p-6 space-y-4 text-lg">
          <Link to="/" onClick={handleNav}>
            <li className="p-2 border-b">Home</li>
          </Link>
          <Link to="/club" onClick={handleNav}>
            <li className="p-2 border-b">Club</li>
          </Link>

          <Link to="/venue-fees" onClick={handleNav}>
            <li className="p-2 border-b">Venues & Fees</li>
          </Link>
          <Link to="/what-is-judo" onClick={handleNav}>
            <li className="p-2 border-b">What is Judo</li>
          </Link>
          <Link to="/team" onClick={handleNav}>
            <li className="p-2 border-b">Team</li>
          </Link>
          <Link to="/calendar" onClick={handleNav}>
            <li className="p-2 border-b">Calendar</li>
          </Link>
          <Link to="/gallery" onClick={handleNav}>
            <li className="p-2 border-b">Gallery</li>
          </Link>
          <Link to="/links" onClick={handleNav}>
            <li className="p-2 border-b">Links</li>
          </Link>
          <Link to="/contact" onClick={handleNav}>
            <li className="p-2">Contact</li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
